// extracted by mini-css-extract-plugin
module.exports = {"item":"Operation_style_item__1Iv7l","separator":"Operation_style_separator__119MJ"};